(ns kyber.components.composite.tab-bar
  (:require [reagent.core :as reagent]
            [re-frame.core :as re-frame]
            [cemerick.url :refer [url]]

            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.components.base.text :as text]
            [kyber.components.base.button :as button]
            [kyber.utils :as ku]))

(def classes
  (styles->classes
   {:tab-bar-container
    {:display :flex
     :flex-direction :column
     :width "100%"
     :height "100%"
     :overflow :hidden}

    :tab-bar-tabs-container
    {:position :relative
     :width "100%"
     :margin [[(gs [:spacing :p20]) :auto (gs [:spacing :p0]) :auto]]
     :border-bottom (str "1px solid " (gs [:colors :gray-scale-200]))

     "&:after"
     {:content "\"\""
      :width "100%"
      :position :absolute
      :bottom 0}}

    :tab-bar-tab-container
    {:display :inline-block
     :margin-right "1px"

     "&:first-child"
     {:margin-left (gs [:spacing :p20])}

     (gs [:queries :mobile-landscape])
     {"&:first-child"
      {:margin-left (gs [:spacing :p0])}}

     "&:last-child"
     {:margin-right (gs [:spacing :p0])}

     "&.active"
     {"& > button"
      {:background-color (gs [:colors :true-white])
       :cursor :auto

       "& > *"
       {:color (gs [:colors :gray-scale-500])}}}

     "& > button"
     {:box-shadow :none
      :border :none

      "& > span"
      {:text-transform :uppercase

       (gs [:queries :mobile-landscape])
       {:font-size ".8em"}}

      (gs [:queries :hover])
      {"&:hover"
       {:box-shadow :none}}}}}))

(defn update-url-query
  "Given a tab key, will update the url using pushState to transition tabs"
  [tab-key]
  (re-frame/dispatch [:router/nav-to (ku/get-next-tab-url tab-key)]))

(defn- get-active-tab
  [tabs]
  (let [{tab-name "tab"} (-> js/window
                             .-location
                             url
                             .-query)
        tab (when (some? tab-name)
              (->> tabs
                   (filter #(= (:key %) (keyword tab-name)))
                   (first)))]

    (reagent/atom (if (some? tab)
                    tab
                    (first tabs)))))

(defn- render-pill
  [label]
  [text/caption-10 :p
   {:style {:color (gs [:colors :true-white])
            :background (gs [:colors :warning-500])
            :padding-top (gs [:spacing :p2])
            :padding-bottom (gs [:spacing :p2])
            :padding-left (gs [:spacing :p8])
            :padding-right (gs [:spacing :p8])
            :display :inline-block
            :margin (str "0px 0px 0px " (gs [:spacing :p8]))
            :border-radius (gs [:radius :r40])}}
   label])

(defn- render-tab-button
  [{:keys [tab active-tab label]}]
  (let [{:keys [key disabled]}
        tab]

    [:div (cond-> {:class [(:tab-bar-tab-container classes)
                           "tab-bar-tab-container"]}
            (= key (:key @active-tab))
            (update :class conj "active"))
     [button/secondary-button
      (cond-> {:role "tab"
               :aria-selected (str (= key (:key @active-tab)))}
        (not= key (:key @active-tab))
        (assoc :on-click (fn [_]
                           (reset! active-tab tab)
                           (update-url-query key)))

        (and (some? disabled)
             (ifn? disabled))
        (assoc :disabled (disabled)))
      (if (some? label)
        [:div (:name tab) (render-pill label)]
        [:div (:name tab)])]]))

(defn render
  [{:keys [tabs]}]
  (let [active-tab (get-active-tab tabs)
        query (re-frame/subscribe [:router/route-query])]
    (fn [{:keys [tabs container-styles]}]
      (let [controlled-tab-key
            (-> @query
                (get "tab")
                (keyword))

            controlled-tab
            (->> tabs
                 (filter #(= controlled-tab-key (:key %)))
                 (first))]

        ;; Will only be triggered when tabs are programmatically updated
        ;; by a route change.
        (when (and (some? controlled-tab)
                   (not= @active-tab controlled-tab))
          (reset! active-tab controlled-tab))

        [:div (cond-> {:class [(:tab-bar-container classes)]}
                (some? container-styles)
                (update :style merge container-styles))
         [:div {:class (:tab-bar-tabs-container classes)
                :role "tablist"}
          (for [{:keys [key label] :as tab} tabs]
            ^{:key key}
            [render-tab-button {:active-tab active-tab
                                :tab tab
                                :label label}])]
         (:render @active-tab)]))))
